export const blogCategories = [
  // { label: "Artificial Intelligence", value: "artificial-intelligence" },
  // { label: "Blockchain", value: "blockchain" },
  // { label: "Cloud Computing", value: "cloud-computing" },
  // { label: "Developer Journey", value: "developer-journey" },
  // { label: "Metaverse", value: "metaverse" },
  // { label: "Press", value: "press" },
  // { label: "Case Studies", value: "case-studies" },
  // { label: "Remote", value: "remote" },
  // { label: "Remote Hiring", value: "remote-hiring" },
  // { label: "Remote Leadership", value: "remote-leadership" },
  // { label: "Remote Work", value: "remote-work" },
  // { label: "Staff Augmentation", value: "staff-augmentation" },
  // { label: "Technical", value: "technical" },
  // { label: "Trends/Insight", value: "trends-insight" },
  // { label: "UI-UX", value: "ui-ux" }

  { label: "Artificial Intelligence", value: "artificial-intelligence" },
  { label: "Blockchain", value: "blockchain" },
  { label: "Cloud Computing", value: "cloud-computing" },
  { label: "Developer Journey", value: "developer-journey" },
  { label: "Metaverse", value: "metaverse" },
  { label: "Press", value: "press", disabled: true },
  { label: "Case Studies", value: "case-studies", disabled: true },
  { label: "Cyber Security", value: "cyber-security" },
  { label: "Listicle", value: "listicle" },
  { label: "Remote", value: "remote" },
  { label: "Remote Hiring", value: "remote-hiring" },
  { label: "Remote Leadership", value: "remote-leadership" },
  { label: "Remote Work", value: "remote-work" },
  { label: "Staff Augmentation", value: "staff-augmentation" },
  { label: "Technical", value: "technical" },
  { label: "Trends/Insight", value: "trends-insight" },
  { label: "UI-UX", value: "ui-ux" },
  { label: "Web3", value: "web3" },
]


export const getCategoryName = (value) => {
  return blogCategories?.find(e => e?.value === value)?.label || 'Category not found'
}
